import { render, staticRenderFns } from "./LandingForwarder.vue?vue&type=template&id=7124de43&"
import script from "./LandingForwarder.vue?vue&type=script&lang=js&"
export * from "./LandingForwarder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/agent_x64/_work/4/s/TravelportTH/Responsive GO/galileo-online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
